import { mapGetters } from 'vuex';
import webChats from '@/mixins/webChats';
import partnerDataCurrentMutation from '@/mixins/currentMutation/partnerDataCurrentMutation';
import dashboardServiceDefinitions from '@/mixins/dashboardServiceDefinitions';
export default {
  mixins: [webChats, partnerDataCurrentMutation, dashboardServiceDefinitions],
  computed: {
    showNeedHelpContacts: {
      get() {
        return this.$store.state.general.showNeedHelpContacts;
      },
      set(value) {
        this.$store.commit('general/setShowNeedHelpContacts', value);
      }
    },
    ...mapGetters({
      needHelpInverted: 'general/needHelpInverted',
      showNeedHelp: 'general/showNeedHelp'
    }),
    inverted() {
      return this.$vuetify.breakpoint.smAndDown ? false : this.needHelpInverted;
    },
    supportChat() {
      return this.$t('dashboard.supportBox.chat');
    },
    customerService() {
      return this.$t('dashboard.supportBox.customerService');
    },
    assistanceService() {
      return this.$t('dashboard.supportBox.assistanceService');
    },
    supportOnline() {
      const dateNow = new Date();
      const currentHourInCET = dateNow.getUTCHours() + dateNow.getTimezoneOffset() / -60;
      return currentHourInCET >= 8 && currentHourInCET < 17;
    },
    chatSubtitle() {
      if (this.supportOnline) {
        return this.$t('dashboard.supportBox.chat.textOnline');
      } else {
        return this.$t('dashboard.supportBox.chat.textOffline');
      }
    },
    covidService() {
      return this.$t('dashboard.supportBox.covidService');
    },
    boxTitle() {
      return this.$t('dashboard.supportBox.boxTitle');
    },
    chatButton() {
      return [
        {
          text: this.supportChat.button,
          action: this.startChat
        }
      ];
    },
    isTescoCzSk() {
      return (
        this.$auth?.user?.benefit?.active &&
        (this.partnerData?.url === 'tescosk' || this.partnerData?.url === 'tescocz')
      );
    },
    serviceButtons() {
      return this.isTescoCzSk
        ? [
            {
              subtitle: this.customerService.tescoButtonPhone.subtitle,
              text: this.customerService.tescoButtonPhone.text,
              link: this.customerService.tescoLinkPhone
            },
            {
              subtitle: this.customerService.buttonPhone.subtitle,
              text: this.customerService.buttonPhone.text,
              link: this.customerService.linkPhone
            },
            {
              subtitle: this.customerService.buttonEmail.subtitle,
              text: this.customerService.buttonEmail.text,
              link: this.customerService.linkEmail
            }
          ]
        : [
            {
              text: this.customerService.buttonPhone.text,
              link: this.customerService.linkPhone
            },
            {
              text: this.customerService.buttonEmail.text,
              link: this.customerService.linkEmail
            }
          ];
    },
    chatAvailable() {
      return this.$auth.isLoggedIn && !this.isUaRu && this.hasWebchat;
    },
    supportBoxes() {
      const outage = {
        active: this.$t('dashboard.supportBox.outageActive') === 'true',
        dateISO: this.$t('dashboard.supportBox.outageDateISO'),
        showTextAlways: true,
        i18nKey: 'dashboard.supportBox.unavailableOn'
      };

      return [
        {
          title: this.customerService.title,
          text: this.customerService.subtitle,
          icon: this.customerService.icon,
          buttons: this.isTescoCzSk
            ? [
                {
                  subtitle: this.customerService.tescoButtonPhone.subtitle,
                  text: this.customerService.tescoButtonPhone.text,
                  link: this.customerService.tescoLinkPhone,
                  kind: 'phone'
                },
                {
                  subtitle: this.customerService.buttonPhone.subtitle,
                  text: this.customerService.buttonPhone.text,
                  link: this.customerService.linkPhone,
                  kind: 'phone'
                },
                {
                  subtitle: this.customerService.buttonEmail.subtitle,
                  text: this.customerService.buttonEmail.text,
                  link: this.customerService.linkEmail,
                  kind: 'email'
                }
              ]
            : [
                {
                  text: this.customerService.buttonPhone.text,
                  link: this.customerService.linkPhone,
                  kind: 'phone'
                },
                {
                  text: this.customerService.buttonEmail.text,
                  link: this.customerService.linkEmail,
                  kind: 'email'
                }
              ],
          available: true,
          outage
        },
        {
          title: this.supportChat.title,
          text: this.chatSubtitle,
          icon: this.supportChat.icon,
          buttons: this.chatButton,
          available: this.chatAvailable,
          outage: { active: false, dateISO: null, showTextAlways: false }
        },
        {
          title: this.covidLineService.title,
          text: this.covidLineService.text,
          icon: this.covidService.icon,
          buttons: this.covidLineService.buttons,
          available: this.covidLineAvailable,
          outage: { active: false, dateISO: null, showTextAlways: false }
        }
      ].filter(box => box.available);
    }
  },
  methods: {
    startChat() {
      this.showWebChat();
      const intervalId = setInterval(() => {
        const element = document.getElementsByClassName('dw-button')[0];
        if (element) {
          element.click();
          clearInterval(intervalId);
        }
      }, 100);
      setTimeout(() => {
        clearInterval(intervalId);
      }, 2000);
    }
  }
};
